import createGenericContext from '../../../context/Context';
import { ReactNode } from 'react';

interface WithContextProps<T> {
  initialValue: T;
  children: ReactNode;
}

// Create a context type and use it for both Provider and useContextValue
const createGenericContextWrapper = <T,>() => {
  const { Provider, useContextValue } = createGenericContext<T>();
  return { Provider, useContextValue };
};

const { Provider, useContextValue } = createGenericContextWrapper<any>();

const WithContext = <T,>({ initialValue, children }: WithContextProps<T>) => {
  return <Provider initialValue={initialValue}>{children}</Provider>;
};

export default WithContext;
export { useContextValue };
